import { useNavigate } from 'react-router-dom'
import {
  dismissSessionPushBanner,
  useSessionPushBanner,
} from '../../../stores/session-push-banner-store'

/**
 * In-app toast for a session-event push received while the app is open.
 * Matches the existing snackbar pattern (role=status, labelled action) used
 * by session undo / voice-note toasts. z-[80] sits above call overlays so a
 * T-30 warning is visible mid-call — the live-test failure mode.
 */
export function SessionPushBanner() {
  const banner = useSessionPushBanner()
  const navigate = useNavigate()

  if (!banner) return null

  const openSession = () => {
    dismissSessionPushBanner()
    navigate(banner.route)
  }

  const actionLabel = banner.title ? `Open session: ${banner.title}` : 'Open session'

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-[max(0.5rem,var(--safe-top))] z-[80] flex justify-center px-4"
    >
      <div className="pointer-events-auto flex max-w-lg items-start gap-3 rounded-2xl bg-slate-900/95 px-4 py-3 text-white shadow-xl ring-1 ring-white/10 backdrop-blur">
        <button
          type="button"
          onClick={openSession}
          aria-label={actionLabel}
          className="min-w-0 flex-1 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
        >
          <p className="text-sm font-semibold">{banner.title}</p>
          {banner.body ? <p className="mt-0.5 text-xs text-slate-200">{banner.body}</p> : null}
        </button>
        <button
          type="button"
          onClick={openSession}
          aria-label={actionLabel}
          className="a11y-touch-target shrink-0 rounded-full px-3 py-1.5 text-sm font-bold text-amber-300 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300"
        >
          Open
        </button>
        <button
          type="button"
          onClick={dismissSessionPushBanner}
          aria-label="Dismiss session notification"
          className="a11y-touch-target shrink-0 rounded-full px-2 py-1.5 text-sm font-semibold text-slate-300 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
        >
          ×
        </button>
      </div>
    </div>
  )
}
